import { ACTIVE } from "@api/services/investments/shapes/InvestmentStatusEnum";
import { indexProjectInvestmentsOperation } from "@api/services/investments";

import type { Request, Investment } from "../types";

type InvestmentsOutput = {
  data: Investment[];
};

const listProjectInvestments = async (request: Request, projectId: string): Promise<Investment[]> => {
  const { data: projectInvestments } = await request<InvestmentsOutput>(indexProjectInvestmentsOperation, { projectId });

  // NOTE: Consider only active investments for transfer.
  const activeInvestments = projectInvestments
    .filter(({ status }) => status === ACTIVE);

  return activeInvestments;
};

export default listProjectInvestments;
